export class SearchFilter {
    value: string = null;
    disabled: boolean = false;
    negative: boolean = false;
}